import { createImmerReducer } from '@reducers/utils/createReducer';
import * as c from './types';
import { PaginatedRequest } from '@clean-code/types/common';

const DEFAULT_PAGE_SIZE = 100;

const initialState: c.OperatorSettingsState = {
  operatorList: {
    sorting: {
      column: 'name',
      direction: 'asc'
    },
    pagination: {
      page: 1,
      pageSize: DEFAULT_PAGE_SIZE
    }
  },
  operatorPlanning: {
    sorting: {
      column: 'since',
      direction: 'desc'
    },
    pagination: {
      page: 1,
      pageSize: DEFAULT_PAGE_SIZE
    }
  }
};

export default createImmerReducer(initialState, {
  [c.SET_OPERATOR_LIST_SORTING]: (
    draft: c.OperatorSettingsState,
    { payload }: { payload?: c.OperatorSettingsSorting }
  ) => {
    if (!payload) return;
    draft.operatorList.sorting = payload;
  },
  [c.SET_OPERATOR_PLANNING_SORTING]: (
    draft: c.OperatorSettingsState,
    { payload }: { payload?: c.OperatorSettingsSorting }
  ) => {
    if (!payload) return;
    draft.operatorPlanning.sorting = payload;
  },
  [c.SET_OPERATOR_LIST_PAGINATION]: (
    draft: c.OperatorSettingsState,
    { payload }: { payload?: { page?: number; pageSize?: number } }
  ) => {
    if (!payload) return;
    draft.operatorList.pagination = payload;
  },
  [c.SET_OPERATOR_PLANNING_PAGINATION]: (
    draft: c.OperatorSettingsState,
    { payload }: { payload?: Required<PaginatedRequest> }
  ) => {
    if (!payload) return;
    draft.operatorPlanning.pagination = payload;
  }
});
